import axios from 'axios';

const TOKEN_KEY = 'helpconnect_token';

export const getHcToken = () => localStorage.getItem(TOKEN_KEY);
export const setHcToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const hcApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/helpconnect` });

hcApi.interceptors.request.use((config) => {
  const token = getHcToken();
  config.headers = config.headers || {};
  if (token) config.headers.Authorization = `Bearer ${token}`;
  else delete config.headers.Authorization;
  return config;
});

hcApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const url = err.config?.url || '';
    if (err.response?.status === 401 && !url.startsWith('/auth/')) {
      setHcToken(null);
      if (!window.location.pathname.startsWith('/helpconnect/login')) window.location.assign('/helpconnect/login');
    }
    return Promise.reject(err);
  }
);

export const hcError = (err, fallback = 'Something went wrong. Please try again.') => {
  const d = err?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(' ') || fallback;
  return fallback;
};

export const formatDuration = (secs) => {
  const s = Math.max(0, Math.round(secs || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return h ? `${h}h ${m}m` : `${m}m`;
};

export const HC_FALLBACK_COURSE_IMG = 'https://images.unsplash.com/photo-1501504905252-473c47e087f8?crop=entropy&cs=srgb&fm=jpg&q=70&w=800';
